import React, { useState } from "react";

import { IntlShape } from "react-intl";

import useDynamicCallback from "@mapmycustomers/shared/util/hook/useDynamicCallback";
import { Button } from "@mapmycustomers/ui";

import messages from "./messages";

interface DraftDeleteUndoButtonProps {
  intl: IntlShape;
  onUndo: () => Promise<void>;
}

const DraftDeleteUndoButton = ({ intl, onUndo }: DraftDeleteUndoButtonProps) => {
  const [undoInProgress, setUndoInProgress] = useState(false);

  const handleUndo = useDynamicCallback(() => {
    setUndoInProgress(true);
    onUndo().finally(() => setUndoInProgress(false));
  });

  return (
    <Button
      disabled={undoInProgress}
      loading={undoInProgress}
      onClick={handleUndo}
      size="small"
      type="primary"
    >
      {intl.formatMessage(messages.undo)}
    </Button>
  );
};

export default DraftDeleteUndoButton;
